/**
 * @author Fernando Ruano
 * @file routes.js
 * @description Medical Parameters routes
 */

// Pages
import MedicalParametersManagement from '@nephro/pages/MedicalParameters/MedicalParametersManagement';
import MedicalParametersCreation from '@nephro/pages/MedicalParameters/MedicalParametersCreation';
import MedicalParametersViewEdit from '@nephro/pages/MedicalParameters/MedicalParametersViewEdit';

const pathStart = '/main/medical-parameters';
const routes = [
  {
    path: `${pathStart}/`,
    isProtected: true,
    component: MedicalParametersManagement,
    exact: true
  },
  {
    path: `${pathStart}/create`,
    isProtected: true,
    component: MedicalParametersCreation,
    exact: true
  },
  {
    path: `${pathStart}/view/:id`,
    isProtected: true,
    component: MedicalParametersViewEdit,
    exact: true
  },
  {
    path: `${pathStart}/edit/:id`,
    isProtected: true,
    component: MedicalParametersViewEdit,
    exact: true
  },
  { redirect: true, to: `${pathStart}/` }
];

export default routes;
